export { UniversityLogin } from "./UniversityLogin";
